// extracted by mini-css-extract-plugin
export default {"plate":"info-plate_plate__rd-Tg"};